import Fab from "@mui/material/Fab";
import { FullscreenExit } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { fullScreenRS, setFullScreen } from "../../services/redux/ContentSlice";
import { useScreenMode } from "../../services/mui/utils";

export default function FAB() {
  const dispatch = useDispatch();
  const fullScreen = useSelector(fullScreenRS);
  const screenMode = useScreenMode();

  if (screenMode === "mobile") return <></>;

  return (
    <>
      {fullScreen ? (
        <Fab color="primary" aria-label="add" sx={{ position: "fixed", right: 10, bottom: 25, zIndex: 1200 }} onClick={() => dispatch(setFullScreen(!fullScreen ?? false))}>
          <FullscreenExit />
        </Fab>
      ) : (
        <></>
      )}
    </>
  );
}
